import { GameFrame } from '@/features/game-client/game-frame.tsx';
import { gameContextSelector } from '@/features/game-context/store/game-context.ts';
import { FgpGenericProvider } from '@/features/providers/generic-provider/types.ts';
import { GameDataProp } from '@/features/providers/types.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const GenericProviderClient: React.FC<GameDataProp> = ({
  data,
}: GameDataProp) => {
  const { gameName } = useAppSelector(gameContextSelector);
  const { url } = (data as FgpGenericProvider).launchDetails;

  return <GameFrame title={gameName} url={url} />;
};
